import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Header, Notification, SignOutModal } from "components/UI";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";
import { useDenominationStore } from "../store";
import { DenominationDashboardSidebar } from "./DenominationDashboardSidebar";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const Sidebar = styled.div`
  display: none;

  ${({ theme }) => `${theme.breakpoints.up("md")} {
    display: block;
  }`}
`;

const Content = styled.div`
  height: 100vh;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  ${({ theme }) => `${theme.breakpoints.up("md")} {
    flex-basis: 50%;
  }`}
`;

export function DenominationDashboardLayout({
  sidebar = <DenominationDashboardSidebar />
}) {
  const navigate = useNavigate();
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );
  const setHeaderBackground = useCentralStore(
    state => state.setHeaderBackground
  );

  useEffect(() => {
    if (!selectedDenomination) {
      navigate("/churches");
    }
  }, [selectedDenomination]);

  useEffect(() => {
    setHeaderBackground(false);

    return () => setHeaderBackground(true);
  }, []);

  return (
    <Container>
      <Notification />
      <SignOutModal />
      <Sidebar>{sidebar}</Sidebar>
      <Content>
        <Header />
        <Box
          sx={{
            pb: 6,
            px: 3,
            backgroundColor: "#fafafa",
            height: "100vh",
            overflowY: "auto"
          }}
        >
          <Outlet />
        </Box>
      </Content>
    </Container>
  );
}
